<div class="alert-box">
    <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="onCancel()">
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">
            {{ "restore_published_version" | translate }}
        </h4>
    </div>
    <div class="modal-body">
        {{ "draft_display" | translate }}
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-default" (click)="onCancel()">{{ "cancel" | translate }}</button>
        <button type="button" class="btn btn-success" (click)="onConfirm()">{{ "confirm" | translate }}</button>
    </div>
</div>
